import axios from 'lib/axios';


const getDrafts = async () => {
  const { data } = await axios.get(`/draft`);
  return data;
};

const saveDraft = async (payload) => {
  const { data } = await axios.post(`/draft`, payload);
  return data;
};

const editDraft = async (payload) => {
  const { data } = await axios.put(`/draft/${payload.draftId}`, payload);
  return data;
};

const getDraft = async (payload) => {
  const { data } = await axios.get(`/draft/${payload}`);
  return data;
};

const deleteDraft = async (payload) => {
  const { data } = await axios.delete(`/draft/${payload}`);
  return data;
};

const saveFile = async (payload) => {
  const { data } = await axios.post(`/file/getUploadUrl`, payload);
  return data;
};

const uploadDone = async (payload) => {
  const { data } = await axios.post(`/file/uploadDone`, payload);
  return data;
};

const saveTl = async (payload) => {
  // const { data } = await axios.post(`/file/uploadDone`, payload);
  // return data;
  return payload;
};



export {
  getDrafts,
  saveDraft, 
  getDraft,
  saveFile,
  editDraft,
  uploadDone,
  deleteDraft,
  saveTl,
};
